/**
 * Region codes and hreflang values for the public app (SEO alternates, routing).
 * Keep in sync with admin language sidebar:
 * `admin/src/pages/MediaManagement/MediaManagement.jsx` → `LANGUAGES[].countryCode`
 *
 * Order matches that sidebar (US → … → Sweden).
 */
export const PUBLIC_REGION_CODES = [
  'us',
  'gb',
  'au',
  'ie',
  'de',
  'at',
  'es',
  'it',
  'fr',
  'pt',
  'nl',
  'no',
  'fi',
  'dk',
  'se',
];

/** BCP 47 tags for <link rel="alternate" hreflang> — align with admin `LANGUAGES[].code` */
export const REGION_HREFLANG = {
  us: 'en-US',
  gb: 'en-GB',
  au: 'en-AU',
  ie: 'ga-IE',
  de: 'de-DE',
  at: 'de-AT',
  es: 'es-ES',
  it: 'it-IT',
  fr: 'fr-FR',
  pt: 'pt-PT',
  nl: 'nl-NL',
  no: 'no-NO',
  fi: 'fi-FI',
  dk: 'da-DK',
  se: 'sv-SE',
};
